import React, { Component } from "react";
import { connect } from "react-redux";
import "./legalRemarks.scss";
import util from "../../_helpers/util";
import DatePicker from "react-datepicker";
import { apis } from "../../actions";
import { confirmAlert } from "react-confirm-alert";
import { config } from "../../_config/_config";
import MandatorySymbol from "../common/MandatorySymbol";
import CustomDropdown from "../common/CustomDropdown";

const step = 7;
const page = "legalRemarks";
class LegalRemarks extends Component {
  constructor(props) {
    super(props);

    const formattedDate = new Date();
    this.state = {
      newApplication: true,
      canApply: true,
      errors: {},
      form: {
        Veteran: "no",
        Race: "",
        gender: "",
        FullName: "",
        txtDate: formattedDate,
        agreement: [],
        Question2: "",
        Question3: "",
        documentConsents: {
          doc1: "",
          doc2: "",
          doc3: "",
          doc4: "",
          doc5: "",
        },
        step: step,
      },
    };
  }

  blur(event) {
    util.blur(event);
  }

  setValue(event) {
    if (event.target.classList.contains("aplcn-has-error")) {
      event.target.classList.remove("aplcn-has-error");
    }
    const name = event.target && event.target.name;
    if (name === "form.Question2" || name === "form.Question3") {
      this.setState((prev) => ({
        errors: { ...prev.errors, [name]: undefined },
      }));
    }
    util.setValue.call(this, event);
    if (util.isblurred(event.target)) {
      var valid = util.validate(event.target);
    }
  }
  handleDateChange(name, date) {
    util.setValue.call(this, null, {
      value: date,
      name: name,
    });
  }

  handleDocumentConsentChange(docKey, value) {
    const newConsents = {
      ...this.state.form.documentConsents,
      [docKey]: value,
    };
    this.setState({
      form: {
        ...this.state.form,
        documentConsents: newConsents,
      },
    });
  }

  submitForm(event) {
    event.preventDefault();
    if (!this.state.canApply) {
      confirmAlert({
        title: "Application Update Restricted",
        message: "You cannot update your job application as it may currently be under review or archived. Please email hr@firestormfire.com if you believe this is incorrect.",
        buttons: [
          {
            label: "Close",
            onClick: () => { },
          },
        ],
      });
      return;
    }
    const documentConsents = this.state.form.documentConsents || {};

    // Check if all consents are "yes"
    const allConsentsGiven =
      documentConsents.doc1 === "yes" &&
      documentConsents.doc2 === "yes" &&
      documentConsents.doc3 === "yes" &&
      documentConsents.doc4 === "yes" &&
      documentConsents.doc5 === "yes";

    // Check if any consent is "no"
    const hasAnyNo =
      documentConsents.doc1 === "no" ||
      documentConsents.doc2 === "no" ||
      documentConsents.doc3 === "no" ||
      documentConsents.doc4 === "no" ||
      documentConsents.doc5 === "no";

    // Block submission if any consent is "no"
    if (hasAnyNo) {
      confirmAlert({
        title: "Consent Required",
        message: "We can only proceed with your application if you have provided consent for all documents. Please review all documents and select 'Yes' for all questions to proceed with the submission.",
        buttons: [
          {
            label: "Close",
            onClick: () => { },
          },
        ],
      });
      return;
    }

    // Block submission if not all consents are "yes"
    if (!allConsentsGiven) {
      confirmAlert({
        title: "Consent Required",
        message: "Please read all documents and provide your consent by selecting 'Yes' for all questions to proceed with the submission.",
        buttons: [
          {
            label: "Close",
            onClick: () => { },
          },
        ],
      });
      return;
    }
    // Validate fitness and drug/smoke policy questions
    const { Question2, Question3 } = this.state.form;
    const questionErrors = {};
    if (!Question2 || Question2 === "no") {
      questionErrors["form.Question2"] =
        Question2 === "no"
          ? "Unfortunately by selecting no, you do not fulfill our requirements for this job."
          : "Please answer this question.";
    }
    if (!Question3 || Question3 === "no") {
      questionErrors["form.Question3"] =
        Question3 === "no"
          ? "Unfortunately by selecting no, you do not fulfill our requirements for this job."
          : "Please answer this question.";
    }
    if (Object.keys(questionErrors).length > 0) {
      this.setState({
        errors: {
          ...this.state.errors,
          ...questionErrors,
        },
      });
      return;
    }

    if (!util.forceVlidate(document.getElementById(page))) {
      return;
    }
    // Convert documentConsents object to JSON string for backend storage
    const formData = {
      ...this.state.form,
      documentConsents: JSON.stringify(this.state.form.documentConsents),
      step
    };

    "function" === typeof this.props.action &&
      this.props.action(formData, step);
  }

  componentDidMount() {
    this.setDefaultData();
    this.props.dispatch(apis.fetchProviderNumber());
  }

  componentDidUpdate(prevProps) {
    const applicationDetails =
      this.props.api && this.props.api.aplicationDetail;
    const prevApplicationDetails =
      prevProps.api && prevProps.api.aplicationDetail;
    const shouldSetDefaultValues = !!(
      (applicationDetails && applicationDetails.hash) !==
      (prevApplicationDetails && prevApplicationDetails.hash)
    );

    if (shouldSetDefaultValues) {
      this.setDefaultData();
    }
  }

  setDefaultData() {
    let newApplication = false;

    if (this.props.api && this.props.api.aplicationDetail) {
      var data = this.props.api.aplicationDetail,
        obj = Object.assign({}, this.state.form);

      if (
        !data.date ||
        data.date === "" ||
        new Date(data.date).getFullYear() < new Date().getFullYear()
      ) {
        newApplication = true;
      } else {
        newApplication = false;
      }

      let form = util._merge(obj, data, {
        Veteran: "veteran",
        FullName: "full_name",
        Race: "race_id",
        Question2: "question2",
        Question3: "question3",
        documentConsents: "document_consents",
        txtDate: {
          target: "date",
          filter: "date",
        },
      });

      if (form.agreement && typeof form.agreement === "string") {
        form.agreement = form.agreement.toLowerCase();
      }

      // Parse documentConsents from JSON string if it exists
      if (form.documentConsents && typeof form.documentConsents === "string") {
        try {
          form.documentConsents = JSON.parse(form.documentConsents);
          // Ensure doc5 exists (for backward compatibility)
          if (!form.documentConsents.hasOwnProperty('doc5')) {
            form.documentConsents.doc5 = "";
          }
        } catch (e) {
          // If parsing fails, use default structure
          form.documentConsents = {
            doc1: "",
            doc2: "",
            doc3: "",
            doc4: "",
            doc5: "",
          };
        }
      } else if (!form.documentConsents) {
        // If documentConsents doesn't exist, initialize with default structure
        form.documentConsents = {
          doc1: "",
          doc2: "",
          doc3: "",
          doc4: "",
          doc5: "",
        };
      } else if (form.documentConsents && typeof form.documentConsents === "object") {
        // Ensure doc5 exists if it's already an object
        if (!form.documentConsents.hasOwnProperty('doc5')) {
          form.documentConsents.doc5 = "";
        }
      }

      this.setState({
        canApply: data.can_apply,
        form,
        sms_provider_opt_out:
          this.props.api.aplicationDetail.sms_provider_opt_out,
      });
    }
  }

  render() {
    var prefetchedData = this.props.api || {};
    const isVeteran = this.props?.api?.aplicationDetail?.veteran;
    return (
      <div className="aplcn-form aplcn-form-two">
        <form method="post" onSubmit={this.submitForm.bind(this)} id={page}>
          <div className="aplcn-form-section-head">
            <h4>Please answer the following</h4>
          </div>

          {/* 1. 60 calendar days */}
          <div className="patrick-aplcn-form-section-head">
            <h5 className="aplcn-is-graduate">
              I understand that this application will be active for ONLY 60 CALENDAR DAYS from the date below. After 60 calendar days, this application will become inactive and if I wish to be considered for another job opening I must re-apply completing a new application form. <MandatorySymbol />
            </h5>
          </div>
          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="yes"
                  type="radio"
                  id="documentConsent1_yes"
                  onChange={() => this.handleDocumentConsentChange("doc1", "yes")}
                  name="form.documentConsents.doc1"
                  checked={this.state.form.documentConsents?.doc1 === "yes"}
                  required
                  title="Document 1 Consent"
                />
                <label htmlFor="documentConsent1_yes">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="no"
                  type="radio"
                  id="documentConsent1_no"
                  onChange={() => this.handleDocumentConsentChange("doc1", "no")}
                  name="form.documentConsents.doc1"
                  checked={this.state.form.documentConsents?.doc1 === "no"}
                  title="Document 1 Consent"
                />
                <label htmlFor="documentConsent1_no">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
          </div>

          {/* 2. Seasonal / temporary */}
          <div className="patrick-aplcn-form-section-head">
            <h5 className="aplcn-is-graduate">
              I understand that this is a seasonal call when needed job and if hired it is on a
              temporary basis only. <MandatorySymbol />
            </h5>
          </div>
          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="yes"
                  type="radio"
                  id="documentConsent3_yes"
                  onChange={() => this.handleDocumentConsentChange("doc3", "yes")}
                  name="form.documentConsents.doc3"
                  checked={this.state.form.documentConsents?.doc3 === "yes"}
                  required
                  title="Document 3 Consent"
                />
                <label htmlFor="documentConsent3_yes">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="no"
                  type="radio"
                  id="documentConsent3_no"
                  onChange={() => this.handleDocumentConsentChange("doc3", "no")}
                  name="form.documentConsents.doc3"
                  checked={this.state.form.documentConsents?.doc3 === "no"}
                  title="Document 3 Consent"
                />
                <label htmlFor="documentConsent3_no">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
          </div>

          {/* 3. Fitness / wildland firefighter */}
          <div className="aplcn-form-row-main aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                <h5 className="aplcn-is-graduate">
                  I have read and understand the physical and mental
                  requirements needed in order to be a wildland firefighter that
                  are explained in the link below. I am qualified and fit to
                  perform these tasks. (For more information on fitness for this
                  job go here: {" "}
                  <a
                    target="_blank"
                    href="https://www.nifc.gov/about-us/our-partners/blm/training/fitness-challenge"
                    rel="noreferrer"
                  >
                    https://www.nifc.gov/about-us/our-partners/blm/training/fitness-challenge
                  </a>
                  ) {" "}
                  <MandatorySymbol />
                </h5>
              </div>
            </div>
          </div>
          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="yes"
                  type="radio"
                  id="legalRemarksQuestion2Yes"
                  onChange={this.setValue.bind(this)}
                  name="form.Question2"
                  checked={this.state.form.Question2 === "yes"}
                />
                <label htmlFor="legalRemarksQuestion2Yes">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="no"
                  type="radio"
                  id="legalRemarksQuestion2No"
                  onChange={this.setValue.bind(this)}
                  name="form.Question2"
                  checked={this.state.form.Question2 === "no"}
                />
                <label htmlFor="legalRemarksQuestion2No">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
            <div className="error-text">
              {this.state.errors["form.Question2"]}
            </div>
          </div>

          {/* 4. Drug free / smoke-free */}
          <div className="aplcn-form-row-main aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                <h5 className="aplcn-is-graduate">
                  {config.companyNameAbbr} is a drug free and smoke-free work
                  place. If hired, will you comply to our company drug and
                  smoking policies? {" "} <MandatorySymbol />
                </h5>
              </div>
            </div>
          </div>
          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="yes"
                  type="radio"
                  id="legalRemarksQuestion3Yes"
                  onChange={this.setValue.bind(this)}
                  name="form.Question3"
                  checked={this.state.form.Question3 === "yes"}
                />
                <label htmlFor="legalRemarksQuestion3Yes">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="no"
                  type="radio"
                  id="legalRemarksQuestion3No"
                  onChange={this.setValue.bind(this)}
                  name="form.Question3"
                  checked={this.state.form.Question3 === "no"}
                />
                <label htmlFor="legalRemarksQuestion3No">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
            <div className="error-text">
              {this.state.errors["form.Question3"]}
            </div>
          </div>

          {/* 5. HireRight disclosure */}
          <div className="patrick-aplcn-form-section-head">
            <h5 className="aplcn-is-graduate">
              I Have read and understood the{" "}
              <a
                href={`${config.docUrl}HireRight_Disclosure_Statement.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                HireRight disclosure
              </a>
              {" "} <MandatorySymbol />
            </h5>
          </div>
          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="yes"
                  type="radio"
                  id="documentConsent5_yes"
                  onChange={() => this.handleDocumentConsentChange("doc5", "yes")}
                  name="form.documentConsents.doc5"
                  checked={this.state.form.documentConsents?.doc5 === "yes"}
                  required
                  title="Document 5 Consent"
                />
                <label htmlFor="documentConsent5_yes">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="no"
                  type="radio"
                  id="documentConsent5_no"
                  onChange={() => this.handleDocumentConsentChange("doc5", "no")}
                  name="form.documentConsents.doc5"
                  checked={this.state.form.documentConsents?.doc5 === "no"}
                  title="Document 5 Consent"
                />
                <label htmlFor="documentConsent5_no">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
          </div>

          {/* 6. Company Policy */}
          <div className="patrick-aplcn-form-section-head">
            <h5 className="aplcn-is-graduate">
              I Have read and understood PatRick Environmental, Inc.{" "}
              <a
                href={`${config.docUrl}FinalCompanyPolicy2026AI.pdf`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Company Policy
              </a>
              {" "}and I understand it. <MandatorySymbol />
            </h5>
          </div>
          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="yes"
                  type="radio"
                  id="documentConsent4_yes"
                  onChange={() => this.handleDocumentConsentChange("doc4", "yes")}
                  name="form.documentConsents.doc4"
                  checked={this.state.form.documentConsents?.doc4 === "yes"}
                  required
                  title="Document 4 Consent"
                />
                <label htmlFor="documentConsent4_yes">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="no"
                  type="radio"
                  id="documentConsent4_no"
                  onChange={() => this.handleDocumentConsentChange("doc4", "no")}
                  name="form.documentConsents.doc4"
                  checked={this.state.form.documentConsents?.doc4 === "no"}
                  title="Document 4 Consent"
                />
                <label htmlFor="documentConsent4_no">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
          </div>

          {/* 7. I hereby certify */}
          <div className="patrick-aplcn-form-section-head">
            <h5 className="aplcn-is-graduate">
              I hereby certify that the statements made by me in answer to the foregoing
              questions are true, complete, and correct to the best of my knowledge and belief. I
              understand that any false statements or any required information withheld from this
              form may provide grounds for the IMMEDIATE withdrawal of any offer of
              appointment or dismissal if an appointment has been accepted. <MandatorySymbol />
            </h5>
          </div>
          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="yes"
                  type="radio"
                  id="documentConsent2_yes"
                  onChange={() => this.handleDocumentConsentChange("doc2", "yes")}
                  name="form.documentConsents.doc2"
                  checked={this.state.form.documentConsents?.doc2 === "yes"}
                  required
                  title="Document 2 Consent"
                />
                <label htmlFor="documentConsent2_yes">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="no"
                  type="radio"
                  id="documentConsent2_no"
                  onChange={() => this.handleDocumentConsentChange("doc2", "no")}
                  name="form.documentConsents.doc2"
                  checked={this.state.form.documentConsents?.doc2 === "no"}
                  title="Document 2 Consent"
                />
                <label htmlFor="documentConsent2_no">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
          </div>

          <div className="aplcn-form-section-head">
            <h4>Legal And Final Remarks</h4>
          </div>
          <div className="aplcn-form-row-main aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-12 aplcn-inp-wrap">
                {/* <p className="aplcn-desc aplcn-txt-big">
                  <i className="fa fa-info-circle" aria-hidden="true" /> The
                  following questions are optional, but we are required to ask
                  them due to our contractual obligations with the US Federal
                  Government.
                </p> */}
                <p className="aplcn-desc aplcn-txt-big">
                  {config.companyName} is committed to ensuring equal opportunity in the recruitment,
                  selection, and advancement of all employees, including individuals with disabilities. We
                  strive to maintain a workforce that reflects the ethnic and cultural diversity of the
                  communities we serve.
                </p>
                <p className="aplcn-desc aplcn-txt-big">
                  To support and strengthen these efforts, we invite you to provide the following information.
                  Please note that this information is voluntary and will not be used in evaluating your
                  application.
                </p>

                <p className="aplcn-desc aplcn-txt-big">
                  However, we are required to ask them in accordance with our contractual obligations with
                  the U.S. Federal Government.
                </p>

                {/* <p className="aplcn-desc aplcn-txt-big">
                  {config.companyName} will ensure that employees and applicants shall not
                  be subjected to harassment due to their status described
                  above, or any harassment, intimidation, threats, coercion, or
                  discrimination because they have engaged in or may engage in
                  any of the following activities: (I) filing a complaint with
                  {config.companyName} or with federal, state, or local agencies regarding
                  status covered under this AAP, (2) assisting or participating
                  in any investigation, compliance review, hearing, or any other
                  activity related to the administration of any federal, state,
                  or local equal employment opportunity or affirmative action
                  statute pertaining to the status covered under this AAP; (3)
                  opposing any act or practice made unlawful by section 503
                  and/or VEVRAA, and (4) exercising any other right protected by
                  section 503 and/or VEVRAA or its implementing regulations in
                  this part.
                </p> */}
              </div>
            </div>
          </div>

          <div className="aplcn-form-row-main  aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <CustomDropdown
                  name="form.gender"
                  value={this.state.form.gender}
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  options={[
                    { id: "Male", value: "Male" },
                    { id: "Female", value: "Female" },
                  ]}
                  placeholder="--- Select Gender ---"
                  required
                  title="Gender"
                />
              </div>

              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <CustomDropdown
                  name="form.Race"
                  value={this.state.form.Race}
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  options={prefetchedData.Race || []}
                  placeholder="--- Select Race ---"
                  required
                  title="Race"
                />
              </div>
            </div>
          </div>

          <div className="aplcn-form-section-head">
            <h5 className="aplcn-is-graduate">Are you a Veteran</h5>
          </div>

          <div className="aplcn-form-row-main">
            <ul className="aplcn-checklist inline-radios">
              <li>
                <input
                  value="Yes"
                  type="radio"
                  id="Veteran1"
                  onChange={this.setValue.bind(this)}
                  name="form.Veteran"
                  checked={this.state.form.Veteran === "Yes"}
                  defaultChecked={isVeteran === "Yes"}
                />
                <label htmlFor="Veteran1">
                  <span className="aplcn-check-label">Yes</span>
                </label>
              </li>
              <li>
                <input
                  value="No"
                  type="radio"
                  id="Veteran23"
                  onChange={this.setValue.bind(this)}
                  name="form.Veteran"
                  checked={this.state.form.Veteran === "No"}
                  defaultChecked={isVeteran === "No"}
                />
                <label htmlFor="Veteran23">
                  <span className="aplcn-check-label">No</span>
                </label>
              </li>
            </ul>
          </div>

          <div>
            <h4>SMS Notification Preference</h4>
            <small style={{ display: "block", color: "#666" }}>
              You can skip this. You will still receive important job-related
              updates via email.
            </small>
            {this.state.sms_provider_opt_out && this.props.api.provider_number ? (
              <p>You've opted out of SMS notifications with our provider. To opt back in, please reply 'START' to {this.props.api.provider_number}. Once done, your SMS notifications will be enabled.</p>
            ) : (
              <>
                <input
                  value="yes"
                  type="checkbox"
                  id="sms_consent"
                  onChange={this.setValue.bind(this)}
                  name="form.sms_consent"
                  title="Form Agreement"
                  className="aplcn-visible-check"
                  checked={util.defaultChecked(
                    "yes",
                    this.state.form.sms_consent
                  )}
                />
                <label style={{ display: "contents" }}>
                  I consent to receive SMS notifications regarding my job
                  application status.
                </label>
              </>
            )}
          </div>

          <div className="aplcn-form-section-head">
            <div className="aplcn-tearms-and-conditions">
              <p>
                Submission of false information is grounds for employment and
                candidacy termination.
              </p>
              <p>
                I hereby authorize {config.companyNameFull} to
                thoroughly investigate my references, work record, education and
                other matters related to my suitability for employment
                (excluding criminal background information) unless otherwise
                specified above. I further, authorize the references I have
                listed to disclose to the company any and all letters, reports
                and other information related to my work records, without giving
                me prior notice of such disclosure. In addition, I hereby
                release the Company, my former employers and all other persons,
                corporations, partnerships and associations from any and all
                claims, demands or liabilities arising out of or in any way
                related to such investigation or disclosure.
              </p>
              <p>
                I verify that all information provided on this application is in
                fact true to the best of my knowledge and understand that if
                information is not true, my candidacy and/or employment will be
                terminated. By filling out your name and dating below is a legal
                agreement between you (the applicant) and {config.companyName} Inc.
              </p>

              <div className="aplcn-form-row-main">
                <ul className="aplcn-checklist inline-radios">
                  <li className="aplcn-green-check">
                    <input
                      value="yes"
                      type="checkbox"
                      id="agreement_12"
                      onChange={this.setValue.bind(this)}
                      name="form.agreement"
                      required
                      title="Form Agreement"
                      className="aplcn-visible-check"
                      checked={util.defaultChecked(
                        "yes",
                        this.state.form.agreement,
                      )}
                    />
                    <label htmlFor="agreement_12">
                      <span className="aplcn-check-label">
                        I agree to the above statement
                      </span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="aplcn-form-row-main  aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <input
                  type="text"
                  placeholder="Type legal full name"
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.FullName}
                  name="form.FullName"
                  required
                  title="Legal Full Name"
                />
              </div>
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <DatePicker
                  className="legal-remark-date-picker"
                  selected={this.state.form.txtDate}
                  showYearDropdown
                  onChange={this.handleDateChange.bind(this, "form.txtDate")}
                  placeholderText="Todays Date"
                  // dateFormat={util._datePickerFormat()}
                  required
                  disabled
                  minDate={new Date()}
                  title="Date"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 aplcn-form-main-actionbar">
              <div className="aplcn-form-actionbar">
                <button
                  onClick={this.back.bind(this)}
                  type="button"
                  disabled=""
                  className="aplcn-prev-button"
                >
                  Previous
                </button>
                <button
                  type="submit"
                  className="aplcn-next-btn"
                >
                  {this.state.newApplication ? "Save" : "Update"}
                </button>
              </div>
            </div>
          </div>
        </form >
      </div >
    );
  }

  back(event) {
    event.preventDefault();
    this.props.back(step);
  }
}
function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(LegalRemarks);
export { connectedApp as LegalRemarks };
